import { FC } from "react"
import { Stack } from "@mui/material"
import { TextFieldElement } from "react-hook-form-mui"
import { RtkHookForm } from "@/core/components"
import { Userbot } from "../../interfaces"
import { useUpdateAccountMutation } from "../../store"

interface IProps {
  account: Userbot.Account
  onDone?: () => void
}

interface IFormData {
  phone: string
  comment: string
  twoFaPassword: string
}

/** Тримит phone/comment (пустое → null); twoFaPassword отправляется как есть,
 *  если непустой (даже 1..5 символов), иначе — опускается из body. */
export const toUpdateAccountBody = (
  phone: string,
  comment: string,
  twoFaPassword: string,
): Userbot.UpdateAccount => ({
  phone: phone.trim() || null,
  comment: comment.trim() || null,
  ...(twoFaPassword.trim() ? { twoFaPassword } : {}),
})

export const AccountForm: FC<IProps> = ({ account, onDone }) => {
  const defaultValues: IFormData = {
    phone: account.phone ?? "",
    comment: account.comment ?? "",
    twoFaPassword: "",
  }

  return (
    <RtkHookForm<IFormData, Userbot.Account>
      successMessage="Аккаунт обновлён"
      mutationHook={useUpdateAccountMutation as never}
      getSubmitHandlerParams={(data) => ({
        id: account.id,
        body: toUpdateAccountBody(data.phone, data.comment, data.twoFaPassword),
      })}
      afterSubmit={() => onDone?.()}
      formContextParams={{ defaultValues }}
      actions={[
        {
          text: "Сохранить",
          type: "submit",
          variant: "contained",
          fullWidth: true,
        },
      ]}
    >
      <Stack spacing={2}>
        <TextFieldElement<IFormData>
          name="phone"
          label="Телефон (E.164 без +)"
          placeholder="79991234567"
        />
        <TextFieldElement<IFormData>
          name="twoFaPassword"
          label="Текущий 2FA-пароль"
          type="password"
          placeholder="Текущий 2FA-пароль"
          helperText="Заполняйте только для изменения/установки текущего пароля (не отображается)"
          autoComplete="new-password"
        />
        <TextFieldElement<IFormData>
          name="comment"
          label="Комментарий"
          multiline
        />
      </Stack>
    </RtkHookForm>
  )
}
